module.exports = __webpack_public_path__ + "img/Custom-Reports.2fd98454.jpg";